
interface AuthErrorStateProps {
  retryAuth: () => void;
}

export const AuthErrorState = ({ retryAuth }: AuthErrorStateProps) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
      <p className="text-red-600 mb-4">
        We're having trouble loading your account.
      </p>
      <button 
        onClick={retryAuth} 
        className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded transition-colors"
      >
        Try Again
      </button>
    </div>
  );
};
